import { useApi } from '../composables'
import http from '../composables/src/useHttp'

export const getAllSlas = () => {
  return useApi(http.get('/settings/slas'))
}

export const fetchSlaGoals = (id: string) => {
  return useApi(http.get(`/settings/sla/${id}/goals`))
}

export const deleteSla = (id: string) => {
  return useApi(http.delete(`/settings/slas/${id}`))
}

export const createSla = (data: any) => {
  return useApi(http.post('/settings/slas', data))
}

export const updateSla = (id: string, data: any) => {
  return useApi(http.put(`/settings/slas/${id}`, data))
}

export const createGoal = (slaId: string, data: any) => {
  return useApi(http.post(`/settings/sla/${slaId}/goals`, data))
}

export const updateGoal = (slaId: string, goalId: string, data: any) => {
  return useApi(http.put(`/settings/sla/${slaId}/goals/${goalId}`, data))
}

export const deleteSlaGoal = (slaId: string, goalId: string) => {
  return useApi(http.delete(`/settings/sla/${slaId}/goals/${goalId}`))
}

export const fetchAllAutomation = () => {
  return useApi(http.get('/settings/automation-rules'))
}

export const fetchAllCalendars = () => {
  return useApi(http.get('/settings/calendars'))
}
